import { Component, type ErrorInfo, type ReactNode } from 'react';

import { ErrorScreen } from './ErrorScreen';

interface ErrorBoundaryProps {
  children: ReactNode;
  onError?: (error: Error, errorInfo: ErrorInfo) => void;
}

interface ErrorBoundaryState {
  hasError: boolean;
  error: Error | null;
}

export class ErrorBoundary extends Component<ErrorBoundaryProps, ErrorBoundaryState> {
  constructor(props: ErrorBoundaryProps) {
    super(props);
    this.state = {
      hasError: false,
      error: null
    };
  }

  static getDerivedStateFromError(error: Error): ErrorBoundaryState {
    return {
      hasError: true,
      error
    };
  }

  componentDidCatch(error: Error, errorInfo: ErrorInfo): void {
    console.error('ErrorBoundary caught an error:', error, errorInfo);
    this.props.onError?.(error, errorInfo);
  }

  handleTryAgain = (): void => {
    this.setState({
      hasError: false,
      error: null
    });
    window.location.reload();
  };

  handleReturnToDashboard = (): void => {
    this.setState({
      hasError: false,
      error: null
    });
    window.location.href = '/';
  };

  render(): ReactNode {
    if (this.state.hasError && this.state.error) {
      return <ErrorScreen onTryAgain={this.handleTryAgain} onReturnToDashboard={this.handleReturnToDashboard} />;
    }

    return this.props.children;
  }
}
